import {useEffect, useState} from "react";
import {useHttp} from "../Context";

export function useFetch < T > (url : URL | string, init?: RequestInit, dependencies: any[]|undefined = undefined) : T | undefined {
    const [result, setResult] = useState < T | undefined > (undefined)
    const httpFetch = useHttp()
    const fetchData = () => {
        httpFetch(url, init).then((resp : any) => {
            resp
                .json()
                .then((data : T) => {
                    setResult(data)
                })
        })
    }
    useEffect(fetchData, [httpFetch, url, init, dependencies]);
    return result
}
